__webpack_require__.p = "https://higherlogiccloudfront.s3.amazonaws.com/ai-assistant/5.1.2/";